var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElMain',[_c('KeepAlive',[(_vm.$route.meta.keepAlive && !_vm.isReload)?_c('RouterView'):_vm._e()],1),(!_vm.$route.meta.keepAlive && !_vm.isReload)?_c('RouterView'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }